import { ElementState } from "@creatomate/preview";
import { IconName } from "@culturehq/components/dist/components/Icon";
import { isSubtitleText } from "components/stories/video-studio/sidebar/tabs/subtitle/utils";

import { IMAGE_TYPE, VIDEO_TYPE } from "components/stories/video-studio/utils/constants";

const getBarStyle = (active: boolean, currentElement: ElementState): {
  backgroundColor: string;
  borderColor: string;
  fontColor: string;
  iconClass: string;
  iconType: IconName;
} => {
  let backgroundColor = "#3f4043";
  let borderColor = "#3f4043";
  let fontColor = "#3f4043";
  let iconClass = "MediaIcon";
  let iconType: IconName = "video-camera-filled-complete";

  switch (currentElement.source.type) {
    case "text":
      if (isSubtitleText(currentElement.source.name)) {
        backgroundColor = "#96caa1";
        borderColor = "#458854";
        fontColor = "#458854";
        iconClass = "SubtitleIcon";
        iconType = "video-marketing";
      } else {
        backgroundColor = "#ffd24b";
        borderColor = "#c39a01";
        fontColor = "#c39a01";
        iconClass = "TextIcon";
        iconType = "text";
      }
      break;
    case IMAGE_TYPE:
      backgroundColor = "#8cb4d6";
      borderColor = "#5c8aac";
      fontColor = "#5c8aac";
      iconType = "image";
      break;
    case VIDEO_TYPE:
      if (active) {
        borderColor = "#c14c4c";
      } else {
        borderColor = "#000000";
      }
      backgroundColor = "#000000";
      fontColor = "#5c8aac";
      break;
    case "audio":
      backgroundColor = "#79b17d";
      borderColor = "#487c4c";
      fontColor = "#487c4c";
      iconClass = "AudioIcon";
      iconType = "musical-note-filled";
      break;
    default:
      break;
  }

  return {
    backgroundColor,
    borderColor,
    fontColor,
    iconClass,
    iconType
  };
};

export default getBarStyle;
